export function eachAxis(callback) {
    return [callback("x"), callback("y")];
}
//# sourceMappingURL=each-axis.js.map